export default __webpack_public_path__ + "static/media/ofertIconGreen.5446ec12.svg";